/* is production */
const isProd = process.env.NODE_ENV === 'production';
if (isProd && location.protocol !== 'https:') {
    location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
}
import './app.css';

import WebFont from 'webfontloader';
import {analyticsEvent, attrEvents} from './js/analytics';

/* fonts */
WebFont.load({
    custom: {
        families: ['DIN Pro:n4,n5,n7', 'Montserrat:n7'],
        urls: ['./css/fonts.css']
    }
    /* ,
    google: {
        families: ['Roboto:400,700:cyrillic']
    },*/
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
/* <button data-event="click" data-event-category="Button" data-event-label="Play"> */
analyticsEvent('Page', 'event', 'Load');
analyticsEvent();
attrEvents();

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    import(/* webpackPrefetch: true */ './js/sw').then(func => {
        func.default();
    });
}

/* lazy loading (https://github.com/verlok/lazyload) */
if (document.querySelector('.lazy') !== null) {
    import(/* webpackPrefetch: true */ './js/lazyloading').then(func => {
        func.default();
    });
}

const setVH = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
setVH();
window.addEventListener('optimizedResize', setVH);

/* share buttons */
if (document.querySelector('.share') !== null) {
    import(/* webpackPrefetch: true */ './js/share').then(func => {
        func.default();
    });
}

import storyteller from './js/viscom/polyoxidonium/promo/storyteller';
import menu from './js/viscom/polyoxidonium/promo/menu';
import links from './js/viscom/polyoxidonium/promo/links';
import routerController from './js/viscom/polyoxidonium/promo/router';

{
    const startProject = () => {
        routerController.init();
        storyteller.init();
        menu.init();
        links.init();
    };

    startProject();
}
